// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Work order day sheet — /workorders/print/:filter (pages/workOrdersPrintPage.js)
   Bare route (no shell). Colours are literal with token fallbacks so the
   sheet looks the same whether or not dashboard-redesign.css is loaded.
   Prefix: .wop- */

.wop-page {
  --wop-ink: #191714;
  --wop-body: #4a453c;
  --wop-muted: #8b8477;
  --wop-muted-2: #a29b8d;
  --wop-line: #e2dcd0;
  --wop-line-soft: #efebe3;
  --wop-canvas: #f4f1ea;
  --wop-gold: var(--rf-brand);
  --wop-gold-lite: var(--rf-brand-lite);
  --wop-gold-tint: var(--rf-brand-tint);
  --wop-band: #5a564f; /* the legacy sheet's dark grey header band */
  --wop-font: 12px;
  min-height: 100vh;
  background: var(--wop-canvas);
  color: var(--wop-ink);
  font-family: "Instrument Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

/* ---------------- toolbar (screen only) ---------------- */
.wop-toolbar {
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 28px;
  padding: 12px 28px;
  background: #fff;
  border-bottom: 1px solid var(--wop-line);
  box-shadow: 0 2px 10px rgba(25, 23, 20, 0.05);
  flex-wrap: wrap;
}
.wop-tb-title {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 220px;
}
.wop-tb-kicker {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--wop-gold);
}
.wop-tb-date {
  font-size: 17px;
  font-weight: 700;
  color: var(--wop-ink);
  white-space: nowrap;
}
.wop-tb-stats {
  display: flex;
  gap: 22px;
  padding: 0 22px;
  border-left: 1px solid var(--wop-line);
  border-right: 1px solid var(--wop-line);
}
.wop-stat {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.15;
}
.wop-stat-v {
  font-size: 19px;
  font-weight: 700;
  color: var(--wop-ink);
  font-variant-numeric: tabular-nums;
}
.wop-stat-k {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--wop-muted-2);
  white-space: nowrap;
}
.wop-tb-controls {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
}
.wop-ctrl {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}
.wop-ctrl-k {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--wop-muted);
}
.wop-stepper,
.wop-segmented {
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--wop-line);
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}
.wop-stepper button,
.wop-segmented button {
  height: 32px;
  border: none;
  background: transparent;
  color: var(--wop-body);
  font: 600 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  transition: background 150ms, color 150ms;
}
.wop-stepper button {
  width: 32px;
  padding: 0;
  font-size: 16px;
}
.wop-stepper button:hover:not(:disabled),
.wop-segmented button:hover:not(.is-on) {
  background: #fdfbf6;
  color: var(--wop-ink);
}
.wop-stepper button:disabled {
  color: #cfc9bc;
  cursor: default;
}
.wop-stepper-v {
  min-width: 30px;
  text-align: center;
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  border-left: 1px solid var(--wop-line);
  border-right: 1px solid var(--wop-line);
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.wop-segmented button + button {
  border-left: 1px solid var(--wop-line);
}
.wop-segmented button.is-on {
  background: var(--wop-gold);
  color: #fff;
}
.wop-btn {
  height: 34px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid var(--wop-line);
  background: #fff;
  color: var(--wop-body);
  font: 600 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: background 150ms, border-color 150ms, color 150ms;
}
.wop-btn svg {
  font-size: 17px;
}
.wop-btn.is-ghost:hover:not(:disabled) {
  background: #fdfbf6;
  border-color: #d8cfb8;
  color: var(--wop-ink);
}
.wop-btn.is-primary {
  background: var(--wop-gold);
  border-color: var(--wop-gold);
  color: #fff;
  padding-right: 20px;
}
.wop-btn.is-primary:hover:not(:disabled) {
  background: var(--rf-brand-hover);
  border-color: var(--rf-brand-hover);
}
.wop-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

/* ---------------- the sheet ---------------- */
.wop-sheet {
  background: #fff;
  margin: 24px auto 48px;
  padding: 26px 30px 22px;
  box-shadow: 0 6px 24px rgba(25, 23, 20, 0.1);
  border-radius: 4px;
  font-size: var(--wop-font);
  line-height: 1.35;
  color: var(--wop-ink);
  /* on screen the sheet previews at roughly the printable width of the paper */
  width: min(96vw, 1440px);
}
.wop-page.is-a4-landscape .wop-sheet {
  width: min(96vw, 1100px);
}
.wop-page.is-a4-portrait .wop-sheet {
  width: min(96vw, 780px);
}

.wop-head {
  display: flex;
  align-items: center;
  gap: 24px;
  padding-bottom: 14px;
  border-bottom: 2px solid var(--wop-ink);
}
.wop-brand {
  flex-shrink: 0;
  width: 150px;
}
.wop-logo {
  height: var(--rf-logo-print-h, 40px);
  max-width: 150px;
  object-fit: contain;
  display: block;
}
.wop-head-mid {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.wop-title {
  margin: 0;
  font: 400 26px/1.1 "Instrument Serif", Georgia, "Times New Roman", serif;
  letter-spacing: 0.01em;
  color: var(--wop-ink);
}
.wop-subtitle {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--wop-gold);
}
.wop-head-date {
  flex-shrink: 0;
  text-align: right;
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}
.wop-date-dow {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--wop-muted);
}
.wop-date-main {
  font-size: 20px;
  font-weight: 700;
  color: var(--wop-ink);
  white-space: nowrap;
}

.wop-summary {
  display: flex;
  gap: 0;
  margin: 12px 0 14px;
  border: 1px solid var(--wop-line);
  border-radius: 6px;
  overflow: hidden;
}
.wop-summary-item {
  flex: 1 1;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  padding: 7px 14px;
  background: #fbfaf7;
}
.wop-summary-item + .wop-summary-item {
  border-left: 1px solid var(--wop-line);
}
.wop-summary-k {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--wop-muted);
}
.wop-summary-v {
  font-size: 15px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

/* ---------------- table ---------------- */
.wop-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: inherit;
}
.wop-c-num {
  width: 32px;
}
.wop-table thead th {
  background: var(--wop-band);
  color: #fff;
  font-size: 0.85em;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-align: left;
  padding: 0.55em 0.7em;
  border-right: 1px solid rgba(255, 255, 255, 0.14);
  vertical-align: middle;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.wop-table thead th:first-child {
  border-radius: 5px 0 0 0;
}
.wop-table thead th:last-child {
  border-right: none;
  border-radius: 0 5px 0 0;
}
.wop-table tbody td {
  padding: 0.55em 0.7em;
  vertical-align: top;
  border-bottom: 1px solid var(--wop-line);
  border-right: 1px solid var(--wop-line-soft);
  color: var(--wop-ink);
  overflow-wrap: anywhere;
}
.wop-table tbody td:last-child {
  border-right: none;
}
.wop-table tbody tr:nth-child(even) td {
  background: #fbfaf7;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.wop-table .wop-num {
  text-align: center;
  color: var(--wop-muted);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.wop-table thead .wop-num {
  color: #fff;
}
.wop-table .wop-center {
  text-align: center;
}
.wop-table .wop-time {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.wop-table .wop-strong {
  font-weight: 700;
}
.wop-sub {
  display: block;
  font-size: 0.8em;
  font-weight: 500;
  color: var(--wop-muted);
  margin-top: 0.15em;
}
/* run sheet: the funeral's service time printed after the destination */
.wop-service {
  white-space: nowrap;
}
.wop-service b {
  font-weight: 700;
}
.wop-empty {
  color: #c4bdad;
}

/* product chips: outlined so they survive greyscale printers */
.wop-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3em;
}
.wop-chip {
  display: inline-flex;
  align-items: baseline;
  gap: 0.3em;
  padding: 0.1em 0.55em;
  border: 1px solid #cfc7b4;
  border-radius: 1em;
  background: #fff;
  font-size: 0.92em;
  font-weight: 600;
  white-space: nowrap;
  line-height: 1.5;
}
.wop-chip.is-cc {
  border-color: var(--wop-gold-lite);
  background: var(--wop-gold-tint);
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.wop-chip-n {
  color: var(--wop-muted);
  font-weight: 700;
  font-size: 0.9em;
}

/* states */
.wop-table .wop-state {
  text-align: center;
  padding: 2.6em 1em;
  color: var(--wop-body);
  font-size: 1.05em;
}
.wop-table .wop-state.is-error {
  color: #a8483e;
}
.wop-table .wop-state .wop-btn {
  margin-left: 14px;
  vertical-align: middle;
}
.wop-skeleton td {
  padding: 0.6em 0.7em !important;
}
.wop-skel {
  display: block;
  height: 1.4em;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0ece3 25%, #f8f6f1 50%, #f0ece3 75%);
  background-size: 200% 100%;
  animation: wop-shimmer 1.3s infinite;
}
@keyframes wop-shimmer {
  from {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
}

.wop-foot {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 14px;
  padding-top: 8px;
  border-top: 1px solid var(--wop-line);
  font-size: 0.85em;
  color: var(--wop-muted);
}

/* ---------------- print ---------------- */
@media print {
  .wop-page {
    background: #fff;
    min-height: 0;
  }
  .wop-toolbar,
  .wop-page .no-print {
    display: none !important;
  }
  .wop-sheet {
    width: auto !important;
    margin: 0;
    padding: 0;
    box-shadow: none;
    border-radius: 0;
  }
  .wop-table thead {
    display: table-header-group;
  }
  .wop-table tr {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .wop-skel {
    animation: none;
  }
  .wop-foot {
    margin-top: 10px;
  }
}

/* ---------------- run sheet details (runSheetPrintPage.js) ---------------- */
.wop-run {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 14px;
}
.wop-run-col {
  border: 1px solid var(--wop-line);
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.wop-run-row {
  display: flex;
}
.wop-run-row > .wop-run-field {
  flex: 1 1;
}
.wop-run-row > .wop-run-field + .wop-run-field {
  border-left: 1px solid var(--wop-line);
}
.wop-run-field {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 0.5em 0.9em;
  min-height: 2.4em;
  background: #fbfaf7;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.wop-run-col > .wop-run-field + .wop-run-field,
.wop-run-col > .wop-run-field + .wop-run-row,
.wop-run-col > .wop-run-row + .wop-run-field {
  border-top: 1px solid var(--wop-line);
}
.wop-run-k {
  flex-shrink: 0;
  width: 13em;
  font-size: 0.8em;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--wop-muted);
}
.wop-run-v {
  font-weight: 600;
  min-width: 0;
  overflow-wrap: anywhere;
}
.wop-run-field.is-sign {
  align-items: flex-end;
}
.wop-run-field.is-sign .wop-run-k {
  width: auto;
}
.wop-run-line {
  flex-grow: 1;
  border-bottom: 1px dashed #a29b8d;
  height: 1.2em;
}
.wop-chip.is-addon {
  border-style: dashed;
  color: var(--wop-body);
}
.wop-page.is-a4-portrait .wop-run {
  grid-template-columns: 1fr;
}

/* ---------------- single work order (workOrderPrintPage.js) ---------------- */
.wop-page.is-a4-portrait .wop-sheet.wop-wo,
.wop-page.is-a4-landscape .wop-sheet.wop-wo {
  width: min(96vw, 860px);
}
.wop-page.is-a4-landscape .wop-sheet.wop-wo {
  width: min(96vw, 1100px);
}
.wop-wo-serial {
  color: var(--wop-gold);
}
.wop-stat-v.is-red,
.wop-wo-flag.is-no {
  color: #a8483e;
}
.wop-wo-flag {
  font-weight: 700;
}
.wop-wo-flag.is-yes {
  color: #4d7a52;
}
.wop-wo-section {
  margin-top: 16px;
}
.wop-wo-h {
  margin: 0 0 6px;
  font-size: 0.8em;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--wop-gold);
  padding-bottom: 4px;
  border-bottom: 1px solid var(--wop-line);
}
.wop-wo-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  background: var(--wop-line);
  border: 1px solid var(--wop-line);
  border-radius: 6px;
  overflow: hidden;
}
.wop-wo-field {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 0.5em 0.9em;
  background: #fff;
  min-width: 0;
}
.wop-wo-field:nth-child(4n + 1),
.wop-wo-field:nth-child(4n + 2) {
  background: #fbfaf7;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.wop-wo-field.is-wide {
  grid-column: 1 / -1;
}
.wop-wo-k {
  flex-shrink: 0;
  width: 12.5em;
  font-size: 0.78em;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--wop-muted);
  line-height: 1.6;
}
.wop-wo-v {
  min-width: 0;
  overflow-wrap: anywhere;
  font-weight: 500;
}
.wop-wo-field.is-strong .wop-wo-v {
  font-weight: 700;
}
.wop-wo-messages {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 10px;
}
.wop-wo-msg {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0.7em 0.9em;
  border: 1px solid var(--wop-line);
  border-radius: 6px;
  min-height: 4.5em;
}
.wop-wo-msg .wop-wo-k {
  width: auto;
}
.wop-wo-msg-v {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-weight: 500;
  line-height: 1.45;
}
.wop-wo-msg.is-card {
  border-color: var(--wop-gold-lite);
  background: var(--wop-gold-tint);
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.wop-wo-msg.is-card .wop-wo-msg-v {
  font-family: "Instrument Serif", Georgia, "Times New Roman", serif;
  font-size: 1.15em;
  font-weight: 400;
}

/* product checklist */
.wop-table .wop-right {
  text-align: right;
}
.wop-wo-products tbody td {
  vertical-align: middle;
}
.wop-wo-group td {
  background: #efebe3 !important;
  font-size: 0.8em;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--wop-body);
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.wop-wo-group-n {
  margin-left: 8px;
  padding: 0 6px;
  border-radius: 8px;
  background: #fff;
  color: var(--wop-muted);
  font-size: 0.95em;
}
.wop-wo-none {
  color: var(--wop-muted);
  font-style: italic;
}
.wop-wo-qty {
  font-weight: 700;
  font-size: 1.1em;
}
.wop-wo-prod {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  flex-wrap: wrap;
}
.wop-wo-code {
  font-size: 0.8em;
}
.wop-wo-price {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.wop-wo-notes {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 4px;
}
.wop-wo-note {
  font-size: 0.95em;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.wop-wo-note-k {
  display: inline-block;
  margin-right: 6px;
  font-size: 0.78em;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--wop-muted);
}
.wop-wo-note.is-red {
  color: #a8483e;
}
.wop-wo-note.is-grey {
  color: var(--wop-body);
}
.wop-box {
  display: inline-block;
  width: 1.3em;
  height: 1.3em;
  border: 1.5px solid var(--wop-ink);
  border-radius: 3px;
  vertical-align: middle;
  background: #fff;
}

.wop-wo-totals {
  display: flex;
  margin-top: 14px;
  border: 1px solid var(--wop-line);
  border-radius: 6px;
  overflow: hidden;
}
.wop-wo-total {
  flex: 1 1;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  padding: 0.6em 0.9em;
}
.wop-wo-total + .wop-wo-total {
  border-left: 1px solid var(--wop-line);
}
.wop-wo-total .wop-wo-k {
  width: auto;
}
.wop-wo-total-v {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.wop-wo-total.is-grand {
  background: var(--wop-band);
  color: #fff;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.wop-wo-total.is-grand .wop-wo-k {
  color: rgba(255, 255, 255, 0.75);
}
.wop-wo-total.is-grand .wop-wo-total-v {
  font-size: 1.15em;
}

.wop-wo-signoff {
  display: flex;
  gap: 24px;
  margin-top: 22px;
}
.wop-wo-sign {
  display: flex;
  align-items: flex-end;
  gap: 10px;
}
.wop-wo-sign .wop-wo-k {
  width: auto;
}
.wop-wo-sign.is-line {
  flex: 1 1;
}
.wop-wo-loading {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
}
.wop-wo-loading .wop-skel {
  height: 2.6em;
}
.wop-wo-state {
  margin-top: 16px;
  border: 1px solid var(--wop-line);
  border-radius: 6px;
}

/* ---------------- funeral slip (A5 landscape) ---------------- */
.wop-slip {
  --slip-w: 720px;
  width: min(96vw, var(--slip-w));
  aspect-ratio: 210 / 148;
  margin: 24px auto 48px;
  padding: 22px 28px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 6px 24px rgba(25, 23, 20, 0.1);
  font-size: calc(var(--wop-font) + 2px);
  color: var(--wop-ink);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
}
.wop-slip-head {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 10px;
  border-bottom: 2px solid var(--wop-ink);
}
.wop-slip-head .wop-logo {
  height: calc(var(--rf-logo-print-h, 40px) * 0.85);
}
.wop-slip-biz {
  font: 400 1.5em/1.1 "Instrument Serif", Georgia, "Times New Roman", serif;
}
.wop-slip-tag {
  margin-left: auto;
  font-size: 0.8em;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--wop-gold);
}
.wop-slip-body {
  display: flex;
  flex-direction: column;
  gap: 0.6em;
  flex-grow: 1;
  justify-content: center;
}
.wop-slip-row {
  display: flex;
  align-items: baseline;
  gap: 14px;
}
.wop-slip-k {
  flex-shrink: 0;
  width: 13.5em;
  font-size: 0.78em;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--wop-muted);
}
.wop-slip-v {
  flex-grow: 1;
  font-weight: 700;
  font-size: 1.1em;
  padding-bottom: 3px;
  border-bottom: 1px dotted #a29b8d;
  min-width: 0;
  overflow-wrap: anywhere;
}
.wop-slip-contact {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding-top: 10px;
  border-top: 1px solid var(--wop-line);
  font-size: 0.9em;
  font-weight: 600;
  color: var(--wop-body);
}
.wop-slip-contact span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.wop-slip-contact svg {
  color: var(--wop-gold);
  font-size: 1.2em;
}
@media print {
  .wop-slip {
    width: auto;
    aspect-ratio: auto;
    height: 100%;
    margin: 0;
    box-shadow: none;
    border-radius: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/work-orders-print.css"],"names":[],"mappings":"AAAA;;;kBAGkB;;AAElB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,2BAA2B;EAC3B,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB,EAAE,6CAA6C;EAClE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,qBAAqB;EACrB,4DAA4D;EAC5D,mCAAmC;AACrC;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,6CAA6C;EAC7C,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,sCAAsC;EACtC,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,gEAAgE;EAChE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,UAAU;EACV,eAAe;AACjB;AACA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,sCAAsC;EACtC,uCAAuC;EACvC,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;EACtB,8DAA8D;EAC9D,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,6DAA6D;AAC/D;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,4CAA4C;EAC5C,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;EACrB,6EAA6E;EAC7E,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,SAAS;EACT,wEAAwE;EACxE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAW;EACX,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,iDAAiD;EACjD,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;EAC5C,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;AACA,wEAAwE;AACxE;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,eAAe;EACf,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,UAAU;EACV,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,4CAA4C;AAC5C;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAW;AACb;AACA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;;;EAGE,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,iCAAiC;EACjC,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;;AAEA,gFAAgF;AAChF;;EAEE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,kEAAkE;EAClE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAW;EACX,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,SAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,sCAAsC;EACtC,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,iDAAiD;AACnD;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":["/* Work order day sheet — /workorders/print/:filter (pages/workOrdersPrintPage.js)\n   Bare route (no shell). Colours are literal with token fallbacks so the\n   sheet looks the same whether or not dashboard-redesign.css is loaded.\n   Prefix: .wop- */\n\n.wop-page {\n  --wop-ink: #191714;\n  --wop-body: #4a453c;\n  --wop-muted: #8b8477;\n  --wop-muted-2: #a29b8d;\n  --wop-line: #e2dcd0;\n  --wop-line-soft: #efebe3;\n  --wop-canvas: #f4f1ea;\n  --wop-gold: var(--rf-brand);\n  --wop-gold-lite: var(--rf-brand-lite);\n  --wop-gold-tint: var(--rf-brand-tint);\n  --wop-band: #5a564f; /* the legacy sheet's dark grey header band */\n  --wop-font: 12px;\n  min-height: 100vh;\n  background: var(--wop-canvas);\n  color: var(--wop-ink);\n  font-family: \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* ---------------- toolbar (screen only) ---------------- */\n.wop-toolbar {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  display: flex;\n  align-items: center;\n  gap: 28px;\n  padding: 12px 28px;\n  background: #fff;\n  border-bottom: 1px solid var(--wop-line);\n  box-shadow: 0 2px 10px rgba(25, 23, 20, 0.05);\n  flex-wrap: wrap;\n}\n.wop-tb-title {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 220px;\n}\n.wop-tb-kicker {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--wop-gold);\n}\n.wop-tb-date {\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--wop-ink);\n  white-space: nowrap;\n}\n.wop-tb-stats {\n  display: flex;\n  gap: 22px;\n  padding: 0 22px;\n  border-left: 1px solid var(--wop-line);\n  border-right: 1px solid var(--wop-line);\n}\n.wop-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  line-height: 1.15;\n}\n.wop-stat-v {\n  font-size: 19px;\n  font-weight: 700;\n  color: var(--wop-ink);\n  font-variant-numeric: tabular-nums;\n}\n.wop-stat-k {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--wop-muted-2);\n  white-space: nowrap;\n}\n.wop-tb-controls {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  flex-wrap: wrap;\n}\n.wop-ctrl {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n}\n.wop-ctrl-k {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--wop-muted);\n}\n.wop-stepper,\n.wop-segmented {\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid var(--wop-line);\n  border-radius: 8px;\n  background: #fff;\n  overflow: hidden;\n}\n.wop-stepper button,\n.wop-segmented button {\n  height: 32px;\n  border: none;\n  background: transparent;\n  color: var(--wop-body);\n  font: 600 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 12px;\n  transition: background 150ms, color 150ms;\n}\n.wop-stepper button {\n  width: 32px;\n  padding: 0;\n  font-size: 16px;\n}\n.wop-stepper button:hover:not(:disabled),\n.wop-segmented button:hover:not(.is-on) {\n  background: #fdfbf6;\n  color: var(--wop-ink);\n}\n.wop-stepper button:disabled {\n  color: #cfc9bc;\n  cursor: default;\n}\n.wop-stepper-v {\n  min-width: 30px;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  border-left: 1px solid var(--wop-line);\n  border-right: 1px solid var(--wop-line);\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.wop-segmented button + button {\n  border-left: 1px solid var(--wop-line);\n}\n.wop-segmented button.is-on {\n  background: var(--wop-gold);\n  color: #fff;\n}\n.wop-btn {\n  height: 34px;\n  padding: 0 16px;\n  border-radius: 8px;\n  border: 1px solid var(--wop-line);\n  background: #fff;\n  color: var(--wop-body);\n  font: 600 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  transition: background 150ms, border-color 150ms, color 150ms;\n}\n.wop-btn svg {\n  font-size: 17px;\n}\n.wop-btn.is-ghost:hover:not(:disabled) {\n  background: #fdfbf6;\n  border-color: #d8cfb8;\n  color: var(--wop-ink);\n}\n.wop-btn.is-primary {\n  background: var(--wop-gold);\n  border-color: var(--wop-gold);\n  color: #fff;\n  padding-right: 20px;\n}\n.wop-btn.is-primary:hover:not(:disabled) {\n  background: var(--rf-brand-hover);\n  border-color: var(--rf-brand-hover);\n}\n.wop-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* ---------------- the sheet ---------------- */\n.wop-sheet {\n  background: #fff;\n  margin: 24px auto 48px;\n  padding: 26px 30px 22px;\n  box-shadow: 0 6px 24px rgba(25, 23, 20, 0.1);\n  border-radius: 4px;\n  font-size: var(--wop-font);\n  line-height: 1.35;\n  color: var(--wop-ink);\n  /* on screen the sheet previews at roughly the printable width of the paper */\n  width: min(96vw, 1440px);\n}\n.wop-page.is-a4-landscape .wop-sheet {\n  width: min(96vw, 1100px);\n}\n.wop-page.is-a4-portrait .wop-sheet {\n  width: min(96vw, 780px);\n}\n\n.wop-head {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding-bottom: 14px;\n  border-bottom: 2px solid var(--wop-ink);\n}\n.wop-brand {\n  flex-shrink: 0;\n  width: 150px;\n}\n.wop-logo {\n  height: var(--rf-logo-print-h, 40px);\n  max-width: 150px;\n  object-fit: contain;\n  display: block;\n}\n.wop-head-mid {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.wop-title {\n  margin: 0;\n  font: 400 26px/1.1 \"Instrument Serif\", Georgia, \"Times New Roman\", serif;\n  letter-spacing: 0.01em;\n  color: var(--wop-ink);\n}\n.wop-subtitle {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--wop-gold);\n}\n.wop-head-date {\n  flex-shrink: 0;\n  text-align: right;\n  display: flex;\n  flex-direction: column;\n  line-height: 1.15;\n}\n.wop-date-dow {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--wop-muted);\n}\n.wop-date-main {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--wop-ink);\n  white-space: nowrap;\n}\n\n.wop-summary {\n  display: flex;\n  gap: 0;\n  margin: 12px 0 14px;\n  border: 1px solid var(--wop-line);\n  border-radius: 6px;\n  overflow: hidden;\n}\n.wop-summary-item {\n  flex: 1 1 0;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 7px 14px;\n  background: #fbfaf7;\n}\n.wop-summary-item + .wop-summary-item {\n  border-left: 1px solid var(--wop-line);\n}\n.wop-summary-k {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--wop-muted);\n}\n.wop-summary-v {\n  font-size: 15px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ---------------- table ---------------- */\n.wop-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: inherit;\n}\n.wop-c-num {\n  width: 32px;\n}\n.wop-table thead th {\n  background: var(--wop-band);\n  color: #fff;\n  font-size: 0.85em;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  text-align: left;\n  padding: 0.55em 0.7em;\n  border-right: 1px solid rgba(255, 255, 255, 0.14);\n  vertical-align: middle;\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n.wop-table thead th:first-child {\n  border-radius: 5px 0 0 0;\n}\n.wop-table thead th:last-child {\n  border-right: none;\n  border-radius: 0 5px 0 0;\n}\n.wop-table tbody td {\n  padding: 0.55em 0.7em;\n  vertical-align: top;\n  border-bottom: 1px solid var(--wop-line);\n  border-right: 1px solid var(--wop-line-soft);\n  color: var(--wop-ink);\n  overflow-wrap: anywhere;\n}\n.wop-table tbody td:last-child {\n  border-right: none;\n}\n.wop-table tbody tr:nth-child(even) td {\n  background: #fbfaf7;\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n.wop-table .wop-num {\n  text-align: center;\n  color: var(--wop-muted);\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n.wop-table thead .wop-num {\n  color: #fff;\n}\n.wop-table .wop-center {\n  text-align: center;\n}\n.wop-table .wop-time {\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n.wop-table .wop-strong {\n  font-weight: 700;\n}\n.wop-sub {\n  display: block;\n  font-size: 0.8em;\n  font-weight: 500;\n  color: var(--wop-muted);\n  margin-top: 0.15em;\n}\n/* run sheet: the funeral's service time printed after the destination */\n.wop-service {\n  white-space: nowrap;\n}\n.wop-service b {\n  font-weight: 700;\n}\n.wop-empty {\n  color: #c4bdad;\n}\n\n/* product chips: outlined so they survive greyscale printers */\n.wop-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3em;\n}\n.wop-chip {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 0.3em;\n  padding: 0.1em 0.55em;\n  border: 1px solid #cfc7b4;\n  border-radius: 1em;\n  background: #fff;\n  font-size: 0.92em;\n  font-weight: 600;\n  white-space: nowrap;\n  line-height: 1.5;\n}\n.wop-chip.is-cc {\n  border-color: var(--wop-gold-lite);\n  background: var(--wop-gold-tint);\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n.wop-chip-n {\n  color: var(--wop-muted);\n  font-weight: 700;\n  font-size: 0.9em;\n}\n\n/* states */\n.wop-table .wop-state {\n  text-align: center;\n  padding: 2.6em 1em;\n  color: var(--wop-body);\n  font-size: 1.05em;\n}\n.wop-table .wop-state.is-error {\n  color: #a8483e;\n}\n.wop-table .wop-state .wop-btn {\n  margin-left: 14px;\n  vertical-align: middle;\n}\n.wop-skeleton td {\n  padding: 0.6em 0.7em !important;\n}\n.wop-skel {\n  display: block;\n  height: 1.4em;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #f0ece3 25%, #f8f6f1 50%, #f0ece3 75%);\n  background-size: 200% 100%;\n  animation: wop-shimmer 1.3s infinite;\n}\n@keyframes wop-shimmer {\n  from {\n    background-position: 200% 0;\n  }\n  to {\n    background-position: -200% 0;\n  }\n}\n\n.wop-foot {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 14px;\n  padding-top: 8px;\n  border-top: 1px solid var(--wop-line);\n  font-size: 0.85em;\n  color: var(--wop-muted);\n}\n\n/* ---------------- print ---------------- */\n@media print {\n  .wop-page {\n    background: #fff;\n    min-height: 0;\n  }\n  .wop-toolbar,\n  .wop-page .no-print {\n    display: none !important;\n  }\n  .wop-sheet {\n    width: auto !important;\n    margin: 0;\n    padding: 0;\n    box-shadow: none;\n    border-radius: 0;\n  }\n  .wop-table thead {\n    display: table-header-group;\n  }\n  .wop-table tr {\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n  .wop-skel {\n    animation: none;\n  }\n  .wop-foot {\n    margin-top: 10px;\n  }\n}\n\n/* ---------------- run sheet details (runSheetPrintPage.js) ---------------- */\n.wop-run {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 14px;\n}\n.wop-run-col {\n  border: 1px solid var(--wop-line);\n  border-radius: 6px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.wop-run-row {\n  display: flex;\n}\n.wop-run-row > .wop-run-field {\n  flex: 1 1 0;\n}\n.wop-run-row > .wop-run-field + .wop-run-field {\n  border-left: 1px solid var(--wop-line);\n}\n.wop-run-field {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  padding: 0.5em 0.9em;\n  min-height: 2.4em;\n  background: #fbfaf7;\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n.wop-run-col > .wop-run-field + .wop-run-field,\n.wop-run-col > .wop-run-field + .wop-run-row,\n.wop-run-col > .wop-run-row + .wop-run-field {\n  border-top: 1px solid var(--wop-line);\n}\n.wop-run-k {\n  flex-shrink: 0;\n  width: 13em;\n  font-size: 0.8em;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--wop-muted);\n}\n.wop-run-v {\n  font-weight: 600;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.wop-run-field.is-sign {\n  align-items: flex-end;\n}\n.wop-run-field.is-sign .wop-run-k {\n  width: auto;\n}\n.wop-run-line {\n  flex-grow: 1;\n  border-bottom: 1px dashed #a29b8d;\n  height: 1.2em;\n}\n.wop-chip.is-addon {\n  border-style: dashed;\n  color: var(--wop-body);\n}\n.wop-page.is-a4-portrait .wop-run {\n  grid-template-columns: 1fr;\n}\n\n/* ---------------- single work order (workOrderPrintPage.js) ---------------- */\n.wop-page.is-a4-portrait .wop-sheet.wop-wo,\n.wop-page.is-a4-landscape .wop-sheet.wop-wo {\n  width: min(96vw, 860px);\n}\n.wop-page.is-a4-landscape .wop-sheet.wop-wo {\n  width: min(96vw, 1100px);\n}\n.wop-wo-serial {\n  color: var(--wop-gold);\n}\n.wop-stat-v.is-red,\n.wop-wo-flag.is-no {\n  color: #a8483e;\n}\n.wop-wo-flag {\n  font-weight: 700;\n}\n.wop-wo-flag.is-yes {\n  color: #4d7a52;\n}\n.wop-wo-section {\n  margin-top: 16px;\n}\n.wop-wo-h {\n  margin: 0 0 6px;\n  font-size: 0.8em;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--wop-gold);\n  padding-bottom: 4px;\n  border-bottom: 1px solid var(--wop-line);\n}\n.wop-wo-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1px;\n  background: var(--wop-line);\n  border: 1px solid var(--wop-line);\n  border-radius: 6px;\n  overflow: hidden;\n}\n.wop-wo-field {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  padding: 0.5em 0.9em;\n  background: #fff;\n  min-width: 0;\n}\n.wop-wo-field:nth-child(4n + 1),\n.wop-wo-field:nth-child(4n + 2) {\n  background: #fbfaf7;\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n.wop-wo-field.is-wide {\n  grid-column: 1 / -1;\n}\n.wop-wo-k {\n  flex-shrink: 0;\n  width: 12.5em;\n  font-size: 0.78em;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--wop-muted);\n  line-height: 1.6;\n}\n.wop-wo-v {\n  min-width: 0;\n  overflow-wrap: anywhere;\n  font-weight: 500;\n}\n.wop-wo-field.is-strong .wop-wo-v {\n  font-weight: 700;\n}\n.wop-wo-messages {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-top: 10px;\n}\n.wop-wo-msg {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 0.7em 0.9em;\n  border: 1px solid var(--wop-line);\n  border-radius: 6px;\n  min-height: 4.5em;\n}\n.wop-wo-msg .wop-wo-k {\n  width: auto;\n}\n.wop-wo-msg-v {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  font-weight: 500;\n  line-height: 1.45;\n}\n.wop-wo-msg.is-card {\n  border-color: var(--wop-gold-lite);\n  background: var(--wop-gold-tint);\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n.wop-wo-msg.is-card .wop-wo-msg-v {\n  font-family: \"Instrument Serif\", Georgia, \"Times New Roman\", serif;\n  font-size: 1.15em;\n  font-weight: 400;\n}\n\n/* product checklist */\n.wop-table .wop-right {\n  text-align: right;\n}\n.wop-wo-products tbody td {\n  vertical-align: middle;\n}\n.wop-wo-group td {\n  background: #efebe3 !important;\n  font-size: 0.8em;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--wop-body);\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n.wop-wo-group-n {\n  margin-left: 8px;\n  padding: 0 6px;\n  border-radius: 8px;\n  background: #fff;\n  color: var(--wop-muted);\n  font-size: 0.95em;\n}\n.wop-wo-none {\n  color: var(--wop-muted);\n  font-style: italic;\n}\n.wop-wo-qty {\n  font-weight: 700;\n  font-size: 1.1em;\n}\n.wop-wo-prod {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 700;\n  flex-wrap: wrap;\n}\n.wop-wo-code {\n  font-size: 0.8em;\n}\n.wop-wo-price {\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n.wop-wo-notes {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 4px;\n}\n.wop-wo-note {\n  font-size: 0.95em;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n.wop-wo-note-k {\n  display: inline-block;\n  margin-right: 6px;\n  font-size: 0.78em;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--wop-muted);\n}\n.wop-wo-note.is-red {\n  color: #a8483e;\n}\n.wop-wo-note.is-grey {\n  color: var(--wop-body);\n}\n.wop-box {\n  display: inline-block;\n  width: 1.3em;\n  height: 1.3em;\n  border: 1.5px solid var(--wop-ink);\n  border-radius: 3px;\n  vertical-align: middle;\n  background: #fff;\n}\n\n.wop-wo-totals {\n  display: flex;\n  margin-top: 14px;\n  border: 1px solid var(--wop-line);\n  border-radius: 6px;\n  overflow: hidden;\n}\n.wop-wo-total {\n  flex: 1 1 0;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 0.6em 0.9em;\n}\n.wop-wo-total + .wop-wo-total {\n  border-left: 1px solid var(--wop-line);\n}\n.wop-wo-total .wop-wo-k {\n  width: auto;\n}\n.wop-wo-total-v {\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n.wop-wo-total.is-grand {\n  background: var(--wop-band);\n  color: #fff;\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n.wop-wo-total.is-grand .wop-wo-k {\n  color: rgba(255, 255, 255, 0.75);\n}\n.wop-wo-total.is-grand .wop-wo-total-v {\n  font-size: 1.15em;\n}\n\n.wop-wo-signoff {\n  display: flex;\n  gap: 24px;\n  margin-top: 22px;\n}\n.wop-wo-sign {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n}\n.wop-wo-sign .wop-wo-k {\n  width: auto;\n}\n.wop-wo-sign.is-line {\n  flex: 1 1 0;\n}\n.wop-wo-loading {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 16px;\n}\n.wop-wo-loading .wop-skel {\n  height: 2.6em;\n}\n.wop-wo-state {\n  margin-top: 16px;\n  border: 1px solid var(--wop-line);\n  border-radius: 6px;\n}\n\n/* ---------------- funeral slip (A5 landscape) ---------------- */\n.wop-slip {\n  --slip-w: 720px;\n  width: min(96vw, var(--slip-w));\n  aspect-ratio: 210 / 148;\n  margin: 24px auto 48px;\n  padding: 22px 28px;\n  box-sizing: border-box;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 6px 24px rgba(25, 23, 20, 0.1);\n  font-size: calc(var(--wop-font) + 2px);\n  color: var(--wop-ink);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 12px;\n}\n.wop-slip-head {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding-bottom: 10px;\n  border-bottom: 2px solid var(--wop-ink);\n}\n.wop-slip-head .wop-logo {\n  height: calc(var(--rf-logo-print-h, 40px) * 0.85);\n}\n.wop-slip-biz {\n  font: 400 1.5em/1.1 \"Instrument Serif\", Georgia, \"Times New Roman\", serif;\n}\n.wop-slip-tag {\n  margin-left: auto;\n  font-size: 0.8em;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--wop-gold);\n}\n.wop-slip-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6em;\n  flex-grow: 1;\n  justify-content: center;\n}\n.wop-slip-row {\n  display: flex;\n  align-items: baseline;\n  gap: 14px;\n}\n.wop-slip-k {\n  flex-shrink: 0;\n  width: 13.5em;\n  font-size: 0.78em;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--wop-muted);\n}\n.wop-slip-v {\n  flex-grow: 1;\n  font-weight: 700;\n  font-size: 1.1em;\n  padding-bottom: 3px;\n  border-bottom: 1px dotted #a29b8d;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.wop-slip-contact {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding-top: 10px;\n  border-top: 1px solid var(--wop-line);\n  font-size: 0.9em;\n  font-weight: 600;\n  color: var(--wop-body);\n}\n.wop-slip-contact span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.wop-slip-contact svg {\n  color: var(--wop-gold);\n  font-size: 1.2em;\n}\n@media print {\n  .wop-slip {\n    width: auto;\n    aspect-ratio: auto;\n    height: 100%;\n    margin: 0;\n    box-shadow: none;\n    border-radius: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
